<template>
  <div class="GlobalFormDemo">
    <GlobalForm
      :init-data="initData"
      :form-rules="formRules"
      :form-item-list="formItemList"
      :needBtnLoading="true"
      :inline="true"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
    >
    <el-form-item label="投诉门店" slot="operationSelect">
        <el-select
          filterable
          v-model="storeId"
          placeholder="请选择或输入门店"
          clearable
        >
          <el-option
            v-for="item in storeList"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
  </GlobalForm>
  </div>
</template>

<script>
import _api from "@/utils/request";
import {formValidateMobile} from '@/utils/form-validate'
import moment from "moment";

export default {
  name: 'Form',
  data() {
    return {
      initData: {
        entryTime: [
          moment().day(moment().day()-92).format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59"),
        ],
      },
      endTime:"",
      startTime:"",
      storeList: [],
      storeId:'',
      formItemList: [
      // {
      //     key: 'staffName',
      //     type: 'input',
      //     labelName: '投诉人',
      //     placeholder: '请输入投诉用户'
      //   },
        {
          key: 'complaintTarget',
          type: 'select',
          labelName: '投诉类型',
          placeholder: '请选择投诉类型',
          option:[{
            value:"00",
            label:"全部",
          },
          {
            value:"02",
            label:"到店回收",
          },
          {
            value:"01",
            label:"上门回收",
          },
          ]
        },
        { slotName: "operationSelect" },
        {
          key: 'entryTime',
          type: 'pickerOptions',
          labelName: '投诉时间',
          placeholder: '请选择投诉时间',
          valueFormat:"timestamp"
        },
      ],
      formRules: {
        mobile: [{
          validator: formValidateMobile,
          trigger: 'blur'
        }]
      }
    }
  },
  created(){
    _api.getStoreSelectOrder().then((res) => {
      this.storeList = res.data;
    });
    this.handleConfirm(this.initData)
  },
  methods: {
    handleConfirm(data, cd) {
      console.log('提交了form', data,this.storeId)
      if(data){
        if(data.entryTime===null){
          this.startTime="",
          this.endTime=""
        }else{
          (this.startTime = moment(data.entryTime[0]).format("x")),
            (this.endTime = moment(data.entryTime[1]).format("x"));
        }
      }else{
        this.startTime="",
        this.endTime=""
      }
      const SeachParams = {
        named:data.staffName,
        id:this.storeId,
        complaintTarget:data.complaintTarget,
        startTime:this.startTime,
        endTime:this.endTime,
        pageNum: 1,
        pageSize: 10,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        }
      }
      this.$emit("changeNav",SeachParams)
    }
  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo{}
</style>
